import React, { PureComponent } from 'react';
import { MonitoredLoadBar, MonitoredLoadBarProps } from './MonitoredLoadBar';
import { LoadClassification } from 'app/model/CORE';
import AppContext from 'app/common/context/AppContext';
import { ConvectionSource } from 'app/model/SOL49';

interface MeteoLoadBarProps extends Omit<MonitoredLoadBarProps, 'fillColor' | 'occupancyPeriods'> {}

export class MeteoLoadBar extends PureComponent<MeteoLoadBarProps> {
    getFillColor = (loadClassification: LoadClassification): string => {
        switch (loadClassification) {
            case LoadClassification.NORMAL: // 1
                return 'rgba(255, 255, 0, 0.45)';
            case LoadClassification.LOW_THRESHOLD: // 2
                return 'rgba(255, 165, 0, 0.45)';
            case LoadClassification.HIGH_THRESHOLD: // 3
                return 'rgba(255, 0, 0, 0.45)';
            case LoadClassification.OVERLOAD: // 4
                return 'rgba(145, 48, 222, 0.45)';
            case LoadClassification.UNDEFINED:
            default:
                return 'rgba(0, 0, 0, 0.0)';
        }
    };

    static getLoadClassification(impactLevel: number): LoadClassification {
        // Little hack for DWD convection which has 5 (1 > 5) levels of classification, but got only 4 load classification
        switch (impactLevel) {
            case 1:
                return LoadClassification.NORMAL;
            case 2:
                return AppContext.getConvectionSource() === ConvectionSource.DWD
                    ? LoadClassification.NORMAL
                    : LoadClassification.LOW_THRESHOLD;
            case 3:
                return AppContext.getConvectionSource() === ConvectionSource.DWD
                    ? LoadClassification.LOW_THRESHOLD
                    : LoadClassification.HIGH_THRESHOLD;
            case 4:
                return AppContext.getConvectionSource() === ConvectionSource.DWD
                    ? LoadClassification.HIGH_THRESHOLD
                    : LoadClassification.OVERLOAD;
            case 5:
                return LoadClassification.OVERLOAD; // DWD only
            default:
                return LoadClassification.UNDEFINED;
        }
    }

    render() {
        return (
            <MonitoredLoadBar
                loadValues={this.props.loadValues}
                monitoredPeriod={this.props.monitoredPeriod}
                currentTime={this.props.currentTime}
                barHeightEm={this.props.barHeightEm}
                fillColor={this.getFillColor}
                hideLabel={this.props.hideLabel}
            />
        );
    }
}
